import { CheckboxGroup, TextSpan } from "@dgs/core";
import { useField } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { EventFormat } from "../../types/eventFormat";
import { FilterAccordionBody, FilterAccordionItem, FilterCheckbox } from "./AccordionFilterItemStyles";

interface Props {
	name: string;
}

export const AccordionItemFormat: FC<Props> = ({ name }) => {
	const { t } = useTranslation();
	const [{ value }, , { setValue }] = useField<EventFormat[]>(name);

	return (
		<FilterAccordionItem
			title={t("Format")}
			initialOpen={true}
			actions={<TextSpan $size="small">{t("IN")}</TextSpan>}
			body={
				<FilterAccordionBody>
					<CheckboxGroup name={name}>
						<FilterCheckbox
							name={EventFormat.ONLINE}
							value={value.some((v) => v === EventFormat.ONLINE)}
							label={t(EventFormat.ONLINE)}
							onChange={(e) =>
								setValue(
									e.target.value ? [...value, EventFormat.ONLINE] : value.filter((v) => v !== EventFormat.ONLINE),
								)
							}
						/>
						<FilterCheckbox
							name={EventFormat.ONSITE}
							value={value.some((v) => v === EventFormat.ONSITE)}
							label={t(EventFormat.ONSITE)}
							onChange={(e) =>
								setValue(
									e.target.value ? [...value, EventFormat.ONSITE] : value.filter((v) => v !== EventFormat.ONSITE),
								)
							}
						/>
						<FilterCheckbox
							name={EventFormat.HYBRID}
							value={value.some((v) => v === EventFormat.HYBRID)}
							label={t(EventFormat.HYBRID)}
							onChange={(e) =>
								setValue(
									e.target.value ? [...value, EventFormat.HYBRID] : value.filter((v) => v !== EventFormat.HYBRID),
								)
							}
						/>
					</CheckboxGroup>
				</FilterAccordionBody>
			}
		/>
	);
};
